import React from "react";
import "./ui.scss";

export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = (props) => (
  <table {...props} className={`table ${props.className || ""}`.trim()} />
);

export default Table;


